import styled from 'styled-components'

export const Container = styled.span`
  border: 1.5px solid #00A988;
  border-radius: 20px;
  color: #00A988;
  font-size: 1rem;
  font-weight: 600;
  padding: 4px 16px;
  white-space: nowrap;
`
